import { Markdown } from '@/components/Markdown';
import {
    useEffect,
    useState
} from 'react';

export const ArtifactMarkdown = ({url, onLoad}: {url: string, onLoad?: () => void}) => {
    const [markdown, setMarkdown] = useState('');
    const getMarkdown = async () => {
        return await fetch(url).then(res => res.text());
    }

    useEffect(() => {
        if(!url){
            return;
        }
        getMarkdown().then(setMarkdown).finally(onLoad);
    }, [url]);

    return (
        <div
            style={{
                padding: '16px', maxWidth: '900px', margin: '0 auto'
            }}
        >
            <Markdown content={markdown} />
        </div>
    )
}